module.exports = __webpack_public_path__ + "img/img_intro_2_deco5.cd861d80.png";